import { render, staticRenderFns } from "./categoryTablevote.vue?vue&type=template&id=22eb6312&scoped=true"
import script from "./categoryTablevote.vue?vue&type=script&lang=js"
export * from "./categoryTablevote.vue?vue&type=script&lang=js"
import style0 from "./categoryTablevote.vue?vue&type=style&index=0&id=22eb6312&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eb6312",
  null
  
)

export default component.exports